import {
    faEnvelope,
    faExclamation,
    faCheck,
    faPen,
    faBoxArchive,
    faFileCircleExclamation,
    faScrewdriverWrench
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";
import "./style.css";

const StatusAnaliseProjeto = ({ value }) => {
    switch (value) {
        case 0:
            return (
                <Tooltip title="Em digitação" placement="right">
                    <div className="status_digitacao">
                        <FontAwesomeIcon icon={faPen} />
                    </div>
                </Tooltip>
            );

        case 1:
            return (
                <Tooltip title="Aguardando análise" placement="right">
                    <div className="status_aguardando">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </div>
                </Tooltip>
            );

        case 2:
            return (
                <Tooltip title="Aguardando documentação" placement="right">
                    <div className="status_aguardando_documentacao">
                        <FontAwesomeIcon icon={faFileCircleExclamation} />
                    </div>
                </Tooltip>
            );

        case 3:
            return (
                <Tooltip title="Aguardando viabilidade técnica" placement="right">
                    <div className="status_aguardando_viabilidade">
                        <FontAwesomeIcon icon={faScrewdriverWrench} />
                    </div>
                </Tooltip>
            );

        case 4:
            return (
                <Tooltip title="Aprovado" placement="right">
                    <div className="status_aprovado">
                        <FontAwesomeIcon icon={faCheck} />
                    </div>
                </Tooltip>
            );

        case 5:
            return (
                <Tooltip title="Revisão" placement="right">
                    <div className="status_revisao">
                        <FontAwesomeIcon icon={faExclamation} />
                    </div>
                </Tooltip>
            );

        case 6:
            return (
                <Tooltip title="Arquivado" placement="right">
                    <div className="status_arquivado">
                        <FontAwesomeIcon icon={faBoxArchive} />
                    </div>
                </Tooltip>
            );

        default:
            return null;
    }
};

export { StatusAnaliseProjeto };